import { Select } from '@truepill/react-capsule'
import { ShippingMethod } from 'types'
import { camelCaseToHumanReadable, shippingMethodToName } from 'utils'

export type SaturdayDeliveryFilterValue = {
  shippingMethod?: ShippingMethod
  optIn?: boolean
}

type SaturdayDeliveryOption = SaturdayDeliveryFilterValue & { label: string }

const SATURDAY_DELIVERY_FILTER_VALUES: Required<SaturdayDeliveryFilterValue>[] = [
  { shippingMethod: ShippingMethod.UpsNextDayAir, optIn: false },
  { shippingMethod: ShippingMethod.UpsSecondDayAir, optIn: false },
  { shippingMethod: ShippingMethod.UpsNextDayAir, optIn: true },
  { shippingMethod: ShippingMethod.UpsSecondDayAir, optIn: true },
]

export const getSaturdayDeliveryFilterLabel = (shippingMethod: ShippingMethod, optIn?: boolean): string => {
  const shippingMethodLabel = camelCaseToHumanReadable(shippingMethodToName[shippingMethod])
  return optIn ? `${shippingMethodLabel} + Opt In` : shippingMethodLabel
}

type SaturdayDeliverySelectProps = {
  shippingMethod?: string
  optIn?: boolean
  onSelect: (value: SaturdayDeliveryFilterValue) => void
}

const SaturdayDeliverySelect = ({
  shippingMethod,
  optIn = false,
  onSelect,
}: SaturdayDeliverySelectProps): JSX.Element => {
  const options = SATURDAY_DELIVERY_FILTER_VALUES.map(value => ({
    ...value,
    label: getSaturdayDeliveryFilterLabel(value.shippingMethod, value.optIn),
  }))
  const selected = options.find(option => option.shippingMethod === shippingMethod && option.optIn === optIn)

  return (
    <Select<SaturdayDeliveryOption | undefined>
      label="Saturday delivery eligibility"
      value={selected}
      placeholder="Select shipping method…"
      options={[{ label: 'Select All' }, ...options]}
      selectedKey="label"
      onChange={option => {
        // "Select All" carries no shippingMethod, which clears the filter
        onSelect({ shippingMethod: option?.shippingMethod, optIn: option?.optIn })
      }}
    />
  )
}

export default SaturdayDeliverySelect
